import {IconButton, Image} from '@yandex-delivery/blocks'
import React, {memo} from 'react'

import {tagToUrl} from '../../lib/tagToUrl'
import type {IconButtonWidgetProps as Props} from '../types'

export const IconButtonWidget = memo(
  ({
    config: {
      accessibility_label,
      image: {image_tag},
    },
  }: Props): React.ReactElement => (
    <IconButton size="m" title={accessibility_label} variant="ghost">
      <Image alt="" height={24} src={tagToUrl(image_tag)} />
    </IconButton>
  ),
)
